'use client'

import React, { FC, ReactElement } from 'react'
import styles from './WalletDetailCard.module.css'
import { HelpOutline } from '@mui/icons-material'
import { Tooltip } from '@mui/material'
import classNames from 'classnames'
import Skeleton from '@/components/skeleton'
import copy from 'copy-to-clipboard'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const WalletDetailCard: FC<{
	tooltip?: string
	detailName?: string
	value?: string | number | React.ReactNode
	valueIcon?: any
	isLoading?: boolean
	detailNameClass?: any
	valueClass?: any
	className?: string
	copy?: boolean
	copyValue?: string
	onClick?: (evt?: any) => void
}> = (props): ReactElement => {
	const { tooltip, value, detailName, copyValue } = props
	const [copied, setCopied] = React.useState(false)

	const handleCopy = () => {
		setCopied(true)
		copy(copyValue as any)
		setTimeout(() => setCopied(false), 1500)
	}

	const handleClick = props?.onClick ? props.onClick : props?.copy ? handleCopy : () => {}

	return (
		<div
			className={classNames(styles.root, {
				[props?.className as any]: !!props?.className,
				[styles.clickable]: !!props?.onClick || !!props?.copy
			})}
			onClick={handleClick}
			role="button"
			tabIndex={0}
			onKeyDown={onKeyboardClick(handleClick)}
		>
			{props?.isLoading ? (
				<Skeleton className={styles.skele} />
			) : (
				<span
					className={classNames(
						styles.walletDetailItemHead,
						props.valueClass,
						'text-xl',
						'semibold',
						{ [styles.copied]: copied }
					)}
				>
					{copied ? 'Copied!' : value}
					{props.valueIcon && <props.valueIcon className={styles.icon} />}
				</span>
			)}
			<div className={styles.detailName}>
				<span
					className={classNames(
						styles.detailNameText,
						'text-xs',
						'semibold',
						props.detailNameClass
					)}
				>
					{detailName}
				</span>
				{!!tooltip && (
					<Tooltip title={tooltip}>
						<HelpOutline style={{ fontSize: 14 }} />
					</Tooltip>
				)}
			</div>
		</div>
	)
}

export default WalletDetailCard
